import React from 'react'

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { detect } from 'detect-browser'

import NoSsr from 'common/components/NoSsr'
import useAutoplayHeroVideo from 'common/hooks/useAutoplayHeroVideo'
import useSale from 'artkive/hooks/useSale'

import VideoPosterTablet from 'images/ecom/home/video-poster/1080p.jpg'
import VideoPosterMobile from 'images/ecom/home/video-poster/cropped-720p.jpg'
import VideoPosterDesktop from 'images/ecom/home/video-poster/poster.jpg'

import Content from './Content'
import { Container, HeroWrap, ImagePlaceholder, Overlay, Video } from './HeroSection.style'
import SaleContent from './SaleContent'

const VIDEO_TAG_ID = 'hero-video'

const browser = detect()

const HeroSection = () => {
  const muiTheme = useTheme()

  const tabletBreakpoint = muiTheme.breakpoints.values.md // 960
  const mobileBreakpoint = muiTheme.breakpoints.values.sm // 600
  const isDesktop = useMediaQuery(muiTheme.breakpoints.up(tabletBreakpoint))
  const isTablet = useMediaQuery(muiTheme.breakpoints.between(mobileBreakpoint, tabletBreakpoint))
  const { isSale } = useSale()

  const isSafariBrowser = browser?.name === 'safari' && browser?.os === 'Mac OS'

  useAutoplayHeroVideo({ id: VIDEO_TAG_ID })

  return (
    <HeroWrap>
      <Container>
        <Overlay />
        <ImagePlaceholder />
        <NoSsr>
          <Video
            id={VIDEO_TAG_ID}
            autoPlay
            muted
            loop
            playsInline
            preload='auto'
            poster={isDesktop ? VideoPosterDesktop : isTablet ? VideoPosterTablet : VideoPosterMobile}
          >
            {isDesktop && !isSafariBrowser && (
              <source
                src='https://artkive-public-assets.s3.us-east-1.amazonaws.com/videos/hero-video-4K.webm'
                type='video/webm'
                media={`(min-width: ${tabletBreakpoint}px)`}
              />
            )}
            <source
              src='https://artkive-public-assets.s3.us-east-1.amazonaws.com/videos/hero-video-4K.mp4'
              type='video/mp4'
              media={`(min-width: ${tabletBreakpoint}px)`}
            />
            <source
              src='https://artkive-public-assets.s3.us-east-1.amazonaws.com/videos/hero-video-1080p.mp4'
              type='video/mp4'
              media={`(min-width: ${mobileBreakpoint}px)`}
            />
            <source
              src='https://artkive-public-assets.s3.us-east-1.amazonaws.com/videos/hero-video-720p.mp4'
              type='video/mp4'
            />
          </Video>
        </NoSsr>
        {isSale ? <SaleContent /> : <Content />}
      </Container>
    </HeroWrap>
  )
}

export default HeroSection
